export const primaryBtnClass = (brandName: string | undefined) => {
  return `${' bg-primary-' + brandName + '-action '}`;
};

export const disabledBtnClass = (brandName: string | undefined) => {
  return `${' bg-muted-' + brandName + '-action '}`;
};

export const disabledHoverBtnClass = (brandName: string | undefined) => {
  return `${' hover:bg-muted-' + brandName + '-action '}`;
};

export const btnHoverClass = (siteId: string | undefined) => {
  switch (siteId) {
    case 'ZBSite':
      return 'hoverButtonZBColor';
    case 'SMSite':
      return 'hoverButtonSMColor';
    case 'ZDSite':
      return 'hoverButtonZDColor';
    case 'MQSite':
      return 'hoverButtonMQColor';
    case 'ZYSite':
      return 'hoverButtonZYColor';
    default:
      return 'hoverButtonZBColor';
  }
};

export const clearanceTextClass = (siteId: string | undefined) => {
  switch (siteId) {
    case 'ZBSite':
      return ' clearanceTextZBColor ';
    case 'SMSite':
      return ' clearanceTextSMColor ';
    case 'ZYSite':
      return ' clearanceTextZYColor ';
    case 'ZDSite':
      return ' clearanceTextZDColor ';
    case 'MQSite':
      return ' clearanceTextMQColor ';
    default:
      return ' clearanceTextZBColor ';
  }
};

export const accountHeadClass = (brandName: string | undefined) => {
  return `${' text-' + brandName + '-accountHeadingColor '}`;
};

export const textHighlightClass = (brandName: string | undefined) => {
  return `${' text-' + brandName + '-highlightColor '}`;
};

export const textLinkColorClass = (brandName: string | undefined) => {
  return `${' text-' + brandName + '-linkColor '}`;
};

export const sideBarClass = (siteId: string | undefined) => {
  switch (siteId) {
    case 'ZBSite':
      return 'sideBarZBcolor';
    case 'SMSite':
      return 'sideBarSMcolor';
    case 'ZDSite':
      return 'sideBarZDcolor';
    case 'MQSite':
      return 'sideBarMQcolor';
    case 'ZYSite':
      return 'sideBarZYcolor';
    default:
      return 'sideBarZBcolor';
  }
};

export const bgColorClass = (brandName: string | undefined) => {
  return `${' bg-' + brandName + '-backgroundColor '}`;
};

export const lazyloadConfig = {
  rootMargin: '100px',
  threshold: 0.1,
};
